import { Link, useNavigate } from "react-router-dom";
import "../styling/Home.css";

import Logo from "../images/logo.png"

// Bars
import topBar from "../images/top-bar.png"
import bottomBar from "../images/bottom-bar.png"
import bottomBar2 from "../images/bottom-bar-2.png"

// Feature images
import structuredLearning from "../images/structured-learning.png"
import focusedPractice from "../images/focused-practice.png"
import interviewSimulation from "../images/interview-simulation.png"
import progressTracking from "../images/progress-tracking.png"
import instantFeedback from "../images/instant-feedback.png"
import smartHints from "../images/smart-hints.png"


export default function Home() {
    const navigate = useNavigate();

    const handleClick = () => {
      navigate('/auth')
    }

    return (
        <div>
            <div className="home-navbar">
              <div className="home-navbar__left">
                <img src={Logo} className="home-navbar__logo"/>
                <Link to="/">Aptix</Link>
              </div>
              <div className="home-navbar__right">
                <Link to="/auth">Login</Link>
                <button className="home-navbar__sign-up-button" onClick={handleClick}>
                  Sign Up
                </button>
              </div>
            </div>
          <div className="title-container">
            <div className="title">
              <h1 className="title__first">Master Investment Banking</h1>
              <h1 className="title__second">One Question at a Time</h1>
            </div>
            <div className="tagline">
              <p className="tagline__text">The first comprehensive platform for mastering investment banking interview questions.</p>
            </div>
            <div className="get-started">
              <button className="get-started__button">
                <Link to="/auth">Get Started</Link>
              </button>
            </div>
          </div>

            <img src={topBar} className="color-bar-top"/>
         <div className="stats">
            <div className="stats__applications">
              <h1 className="stats__stat">100,000+</h1>
              <h2 className="stats__title">Applicants</h2>
            </div>
            <div className="stats__hired">
              <h1 className="stats__stat">900+</h1>
              <h2 className="stats__title">Hired</h2>
            </div>
            <div className="stats__firms">
              <h1 className="stats__stat">100+</h1>
              <h2 className="stats__title">Firms</h2>
            </div>
            <div className="stats__resources">
              <h1 className="stats__stat">20+</h1>
              <h2 className="stats__title">Resources</h2>
            </div>
          </div>
          <div className="problem">
            <img src={bottomBar} className="color-bar-bottom"/>
            <h1 className="problem__title">The Problem</h1>
            <h2 className="problem__subtitle">Investment Banking Interviews Lack Structure and Consistency</h2>
            <div className="problem__info">
              <div className="problem__info__boxes">
                  <div className="problem__info__box">
                    <h1 className="problem__info__box__title">Scattered Resources</h1>
                    <h2 className="problem__info__box__details">No centralized platform for comprehensive interview preparation</h2>
                  </div>
                  <div className="problem__info__box">
                    <h1 className="problem__info__box__title">Lack of Structure</h1>
                    <h2 className="problem__info__box__details">No standardized approach to technical interview preparation</h2>
                  </div>
                  <div className="problem__info__box">
                    <h1 className="problem__info__box__title">No Real-time Feedback</h1>
                    <h2 className="problem__info__box__details">Limited opportunites for practice with immediate feedback</h2>
                  </div>
                </div>
                <div className="challenges">
                  <h1 className="challenges__title">Current Challenges</h1>
                  <ul className="challenges__list">
                    <li className="challenges__list__item">- Only 0.9% of applicants secure positions</li>
                    <li className="challenges__list__item">- Limited access to quality practice materials</li>
                    <li className="challenges__list__item">- Inconsisent interview experiences</li>
                    <li className="challenges__list__item">- High competition for limited positions</li>
                  </ul>
                </div>
            </div>
          </div>
          <img src={bottomBar2} className="color-bar-bottom"/>
          <div className="solution">
            <h1 className="solution__title">Our Solution</h1>
            <h2 className="solution__tagline">A comprehensive platform designed to help you succeed in investment banking interviews</h2>
            <div className="solution__features">
              <div className="solution__features__box">
                <img src={structuredLearning} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Structured Learning</h1>
                <h2 className="solution__features__box__details">Industry specific step-by-step curriculum</h2>
              </div>
              <div className="solution__features__box">
                <img src={focusedPractice} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Focused Practice</h1>
                <h2 className="solution__features__box__details">Targeted exercises for key technical concepts</h2>
              </div>
              <div className="solution__features__box">
                <img src={interviewSimulation} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Real Interview Simulation</h1>
                <h2 className="solution__features__box__details">Practice with real interview scenarios</h2>
              </div>
              <div className="solution__features__box">
                <img src={progressTracking} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Progress Tracking</h1>
                <h2 className="solution__features__box__details">Monitor your improvement with analytics</h2>
              </div>
              <div className="solution__features__box">
                <img src={instantFeedback} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Instant Feedback</h1>
                <h2 className="solution__features__box__details">Get immediate feedback on your answers</h2>
              </div>
              <div className="solution__features__box">
                <img src={smartHints} className="solution__features__box__icon" />
                <h1 className="solution__features__box__feature">Smart Hints</h1>
                <h2 className="solution__features__box__details">Helpful hints when you need them most</h2>
              </div>
            </div>
            <div className="partners">
              <div className="partners__text">
                <h1 className="partners__text__title">Our Partners</h1>
                <p className="partners__text__details">A deep dive into the companies and <br/>organizations that <span id="highlight">endorse Aptix</span></p>
              </div>
              <div className="partners__images">

              </div>
            </div>
          </div>

        </div>
    )
}